export function isLooseValidEmail(email: string): boolean {
    return !/[\s<>]/.test(email) && /.+@.+\..+/.test(email);
}